import {
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  createSelectOptionsFromEnum,
  SelectOption,
} from '@shared/helpers/convention.helpers';
import {OfficerTypeEnum, SalutationEnum} from '@generated/graphql';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import { OfficerCorporateFormType } from '@app/modules/officer/models/form/officer-corporate-form-type';
import { OfficerIndividualFormType } from '@app/modules/officer/models/form/officer-individual-form-type';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { IndividualInfoComponent } from '../individual-info/individual-info.component';
import {CommonModule} from "@angular/common";
import {MatInputModule} from "@angular/material/input";
import {MatSelectModule} from "@angular/material/select";
import {
  CountrySelectInputComponent
} from "@shared/component/common/country-select-input/country-select-input.component";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatDividerModule} from "@angular/material/divider";

@Component({
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    CountrySelectInputComponent,
    MatDatepickerModule,
    NgxMatIntlTelInputComponent,
    MatDividerModule,
    IndividualInfoComponent
  ],
  selector: 'app-corporate-info',
  templateUrl: './corporate-info.component.html',
  styleUrls: ['./corporate-info.component.scss'],
})
export class CorporateInfoComponent implements OnInit {
  @Input() formGroup: FormGroup<OfficerCorporateFormType>;
  @Input() showTypeSelected: boolean = true;

  @ViewChildren(NgxMatIntlTelInputComponent)
  phoneInputs: QueryList<NgxMatIntlTelInputComponent>;

  @ViewChild(IndividualInfoComponent)
  representativeForm: IndividualInfoComponent;

  salutations$: Observable<SelectOption[]> = of(
    createSelectOptionsFromEnum(SalutationEnum),
  );

  get individualForm(): FormGroup<OfficerIndividualFormType> {
    return this.formGroup.get('representative') as FormGroup;
  }

  constructor() { }

  ngOnInit(): void { }

  public typeSelected: OfficerTypeEnum = OfficerTypeEnum.Corporate;

  // private  _role: OfficerRoleEnum;
  //
  // public isDirector(): boolean {
  //   return this._role === OfficerRoleEnum.DIRECTOR;
  // }
  //
  // public isNominee(): boolean {
  //   return this.typeSelected === OfficerTypeEnum.Nominee;
  // }

  public resetForm(): void {
    this.phoneInputs.forEach((i) => i.reset());

    this.representativeForm.resetForm();
  }
}
